import { CoverImageFragment } from "@src/fragments.generated";
import { MediaFragment } from "@src/fragments.generated";
import { getLinkType, LinkType } from "../../../lib/utils/files";

export const getMediaUrl = (
  media: Pick<MediaFragment, "imageUrls" | "mediaUrls" | "unoptimizedUrl">,
  opts?: { thumb?: boolean },
): string => {
  if (
    media.unoptimizedUrl &&
    getLinkType(media.unoptimizedUrl) === LinkType.GIF
  ) {
    return media.unoptimizedUrl;
  }
  if (opts?.thumb && media.imageUrls?.thumb) {
    return media.imageUrls?.thumb;
  }
  return (
    media.imageUrls?.medium || media.imageUrls?.original || media.mediaUrls.en
  );
};

export const getMediaUrlFromKey = (
  key: string,
  mediaDomain: string,
): string => {
  return `https://${mediaDomain}/${key}`;
};

export const getThumbnailUrl = (media: Omit<MediaFragment, "id">): string => {
  return (
    media.unoptimizedUrl ||
    media.imageUrls?.thumb ||
    media.imageUrls?.medium ||
    media.imageUrls?.original ||
    media.mediaUrls.en
  );
};

export const getCoverImageUrl = (
  coverImage: Pick<CoverImageFragment, "imageUrls">,
): string | undefined => {
  return (
    coverImage.imageUrls?.wide ||
    coverImage.imageUrls?.medium ||
    coverImage.imageUrls?.original
  );
};

export const isVimeoRedirectLink = (link: string): boolean => {
  return link.toLowerCase().includes("player.vimeo.com/progressive_redirect/");
};

export const isVideoMedia = (
  media: Pick<MediaFragment, "imageUrls" | "mediaUrls">,
): boolean => {
  if (media.imageUrls) return false;
  const linkType = getLinkType(media.mediaUrls.en);
  return [LinkType.VIDEO, LinkType.MUX_VIDEO, LinkType.HOSTED_VIDEO].includes(
    linkType,
  );
};

// The video editor can't load Mux HLS streams or hosted (YouTube/Vimeo) embeds —
// it needs the original uploaded file. unoptimizedUrl is that source for
// Mux-processed media; otherwise mediaUrls.en is direct.
export const getEditableVideoSrcUrl = (
  media: Pick<MediaFragment, "mediaUrls" | "unoptimizedUrl"> | null | undefined,
): string | undefined => {
  if (!media) return undefined;
  if (
    media.unoptimizedUrl &&
    getLinkType(media.unoptimizedUrl) === LinkType.VIDEO
  ) {
    return media.unoptimizedUrl;
  }
  if (
    media.mediaUrls?.en &&
    getLinkType(media.mediaUrls.en) === LinkType.VIDEO
  ) {
    return media.mediaUrls.en;
  }
  return undefined;
};
